import React from 'react'

function Button({children,onClick,className}) {
  const defaultStyles = 'text-white font-bold py-2 px-4 rounded';
  return (
    <button onClick={onClick} className={`${defaultStyles} ${className}`}>{children}</button>
  )
}

export default Button